/** The colour decisions for ticket status and priority, in one place.
 *
 * Shared by the agent console and the end-user portal so that "resolved" is the
 * same green on both sides of the product. The *wording* is deliberately not
 * shared: the portal says "Awaiting your reply" where the console says "Pending
 * customer", and flattening that would make the portal speak like an internal
 * tool. Each side supplies its own labels and takes the tone from here.
 */
export type BadgeVariant = 'default' | 'neutral' | 'success' | 'warning' | 'critical' | 'info'

export const STATUS_VARIANT: Record<string, BadgeVariant> = {
  new: 'info',
  in_progress: 'default',
  pending_customer: 'warning',
  resolved: 'success',
  closed: 'neutral',
  cancelled: 'neutral',
}

/** P1 is the loudest thing on any screen it appears on; P4 must not compete. */
export const PRIORITY_TONE: Record<string, string> = {
  p1: 'bg-critical/10 text-critical ring-1 ring-inset ring-critical/20',
  p2: 'bg-warning/15 text-warning ring-1 ring-inset ring-warning/25',
  p3: 'bg-info/10 text-info ring-1 ring-inset ring-info/20',
  p4: 'bg-muted text-muted-foreground ring-1 ring-inset ring-border',
}
